import loadable from '@loadable/component';

export const BuyCreditsLinksLoadable = loadable(
  () =>
    import(
      /* webpackChunkName: "BuyCreditsLinks" */
      './BuyCreditsLinks.dynamic'
    ),
);
